(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const checkboxes = document.querySelectorAll(".colour-checkbox");
  const countText = document.getElementById("swatch-count");
  const hiddenInput = document.getElementById("selected-colours");

  if (!checkboxes.length) return;

  checkboxes.forEach(cb => {
    cb.addEventListener("change", function () {
      const selected = Array.from(checkboxes)
        .filter(c => c.checked)
        .map(c => c.value);

      if (selected.length > 4) {
        this.checked = false;
        alert("You can select a maximum of 4 colours.");
        return;
      }

      document.querySelectorAll(".swatch-option").forEach(opt => {
        opt.classList.remove("active");
      });
      selected.forEach(col => {
        const el = document.querySelector(`.swatch-option[data-colour="${col}"]`);
        if (el) el.classList.add("active");
      });

      countText.textContent = `Selected: ${selected.length}/4`;
      hiddenInput.value = selected.join(", ");
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
